import { render, staticRenderFns } from "./JjfaDetails.vue?vue&type=template&id=292ae166&scoped=true"
import script from "./JjfaDetails.vue?vue&type=script&lang=js"
export * from "./JjfaDetails.vue?vue&type=script&lang=js"
import style0 from "./JjfaDetails.vue?vue&type=style&index=0&id=292ae166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292ae166",
  null
  
)

export default component.exports